import { Pipe, PipeTransform, Injectable } from "@angular/core";

@Pipe({
    name: 'enumNames'
})
@Injectable()
export class EnumNamesPipe implements PipeTransform {
    constructor() { }

    transform(value: string[], parsedEnum: any): string[] {
        if (!value) {
            return [""];
        }

        const keys = Object.keys(value);
        const firstHalf = keys.splice(keys.length / 2);

        return firstHalf;
    }
}
